import { Validators } from "@angular/forms";

export const systemDefaultCountryPostcodeValidator = Validators.pattern(/\b\d{5}\b/);
